<template>
    <span @mouseenter="changeActive($event)" @mouseleave="removeActive($event)" ref="pricebody" class="span">
        <span v-if="mode!=3">{{price||'-'}} </span>
        <a>
            <a-popover v-model="visible" trigger="click" placement="bottomLeft"  @click="clickText" @visibleChange="cancel1" :getPopupContainer="()=>this.$refs.pricebody">
            <div slot="content">
                <a-input v-model="newPrice" style="width:104px;margin:0  16px 0 0"></a-input>
                <a @click="confirm">保存</a>&nbsp|&nbsp<a @click="cancel">取消</a>
            </div>
            <a-icon type="edit"  v-if="mode!=3" class="edit-show"/>
            <span v-if="mode==3">{{price||'-'}} </span>
            </a-popover>
        </a>
        <span v-show="mode=='1'&&isShow">
            <a-icon type="rise" v-if="isRise"  :style="{ fontSize: '16px', color: 'rgb(255,50,50)',marginLeft:'10px' }" />
            <a-icon type="fall" v-else :style="{ fontSize: '16px', color: 'rgb(13,237,125)',marginLeft:'10px' }" />
        </span>
    </span>
</template>

<script>
export default {
    name:'editCell',
    props:{
        price: {
            type:String,
        },
        mode:{
            type:String,
            default:''
        },
        isShow:{
            type:Boolean,
            default:false,
        },
        isRise:{
            type:Boolean,
            default:false,
        }
    },
    data(){
        return{
            visible:false,
            newPrice:'',
        }
    },
    created(){
    },
    methods:{
        clickText(){
            this.newPrice =this.price;
        },
        changeActive($event) {
            $event.currentTarget.className = 'active';
        },
        removeActive($event) {
            if (this.visible) {
                    return
                }
            $event.currentTarget.className = '';
        },
        confirm() {
            let params = {
                variantId : this.$route.query.id
            };
            let url = '';
            if (this.mode == '2') {
                params.itemPrice = this.newPrice;
                url = "merchandise/changeItemPrice";//链接价
            } else if(this.mode == '1') {
                params.distributePrice = this.newPrice;
                url = "merchandise/changeDistributePrice";//渠道价
            }   else if(this.mode == '3') {
                params.grossMargin = this.newPrice;
                url = "merchandise/changeGrossMargin";
            }
            this.$http.post(url,params).then(res=>{
                if (res.result) {
                    this.$message.success("修改成功");
                    this.eval = this.newPrice
                    this.cancel();
                    this.$emit('getdata')
                }
                else{
                    this.$message.warning(res.message);
                }
            })
        },
        cancel(){
            this.$refs.pricebody.className='';
            this.visible = false;
        },
        cancel1($event){
            if (!$event) {
                this.$refs.pricebody.className='';
            }
        },
    }

}
</script>
<style lang="less" scoped>
.active {
  .edit-show{
    visibility:visible;
  }
  }
  .edit-show{
    visibility:hidden;
  }
</style>